// 카카오 비즈니스(카카오모먼트) 픽셀 & SDK 이벤트 유틸.
// 기본 픽셀(kp.js)과 최초 pageView는 index.html <head>에 정적 설치돼 있고,
// SPA 내부에서 일어나는 전환(회원가입/구매/검색)은 여기의 함수로 발화한다.
// 트랙 ID는 클라이언트에 노출되는 값(비밀 아님)이라 index.html의 다른 픽셀 ID처럼 하드코딩한다.
const KAKAO_PIXEL_TRACK_ID = '619597828302550169';

type KakaoPixelPurchaseParams = {
  /** 총 수량 */
  total_quantity?: string | number;
  /** 총 결제 금액 */
  total_price?: string | number;
  /** 통화 코드(기본 KRW) */
  currency?: string;
};

type KakaoPixelSearchParams = {
  /** 검색 키워드 */
  keyword?: string;
  /** 추가 분류 태그(선택) */
  tag?: string;
};

type KakaoPixelInstance = {
  pageView: (tag?: string) => void;
  completeRegistration: (tag?: string) => void;
  purchase: (params?: KakaoPixelPurchaseParams) => void;
  search: (params?: KakaoPixelSearchParams) => void;
};

declare global {
  interface Window {
    kakaoPixel?: (trackId: string) => KakaoPixelInstance;
  }
}

/** kp.js가 로드됐을 때만 픽셀 인스턴스를 돌려준다(광고차단/미로드 시 안전하게 no-op). */
const getKakaoPixel = (): KakaoPixelInstance | undefined => {
  if (typeof window === 'undefined' || !window.kakaoPixel) return undefined;
  return window.kakaoPixel(KAKAO_PIXEL_TRACK_ID);
};

/** 회원가입 완료(소셜 로그인 성공 시점 = 이 사이트의 가입 관례). */
export const kakaoTrackCompleteRegistration = () => {
  getKakaoPixel()?.completeRegistration();
};

/** 구매 완료(결제 확정 시점). 금액/수량은 광고 최적화(ROAS)를 위해 함께 전달한다. */
export const kakaoTrackPurchase = ({
  totalPrice,
  totalQuantity = 1,
}: {
  totalPrice: number;
  totalQuantity?: number;
}) => {
  getKakaoPixel()?.purchase({
    total_quantity: totalQuantity,
    total_price: totalPrice,
    currency: 'KRW',
  });
};

/** 검색(검색키워드 포함). 우선순위 밖이라 아직 호출부는 연결하지 않는다. */
export const kakaoTrackSearch = (keyword?: string) => {
  getKakaoPixel()?.search(keyword ? { keyword } : undefined);
};
